// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import "whatwg-fetch";
import Vue from "vue";
import App from "./App";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();
import store from "./plugins/vuex";
import router from "./plugins/router";
import firebase from "firebase/app";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";
import jquery from "jquery";
import axios from "axios";
import Notifications from "vue-notification";
import VueMoment from "vue-moment";
import moment from "moment";
import "./assets/styles/material.scss";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import parse from "date-fns/parse";
import format from "date-fns/format";

Vue.use(Vuetify);
Vue.use(VueMaterial);
Vue.use(Notifications);
Vue.use(require("vue-moment"));

Vue.config.productionTip = false;

let app = "";
//dev
/*
const config = {
  apiKey: "AIzaSyAQcDgYlfmHTK46o2T5FbEEtMO2of8TYIg",
  authDomain: "humanitas-docsharing-pma-dev.firebaseapp.com",
  databaseURL: "https://humanitas-docsharing-pma-dev.firebaseio.com",
  projectId: "humanitas-docsharing-pma-dev",
  storageBucket: "humanitas-docsharing-pma-dev.appspot.com",
  messagingSenderId: "611585503596"
};
*/

//demo
/*
const config = {
  apiKey: "AIzaSyA4dvl8VNS3bm8kAcA1y_7qjvmUINuHDXw",
  authDomain: "grand-brand-240912.firebaseapp.com",
  databaseURL: "https://grand-brand-240912.firebaseio.com",
  projectId: "grand-brand-240912",
  storageBucket: "grand-brand-240912.appspot.com",
  messagingSenderId: "893102606897"
};*/

//prod

const config = {
  apiKey: "AIzaSyDF5PKSLn-cMb7zvUjC8zm3zXJhXgCvKaI",
  authDomain: "humanitas-securedocsharing-pma.com",
  databaseURL: "https://humanitas-securedocsharing-pma.firebaseio.com",
  projectId: "humanitas-securedocsharing-pma",
  storageBucket: "humanitas-securedocsharing-pma.appspot.com",
  messagingSenderId: "39983966337"
};

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
});



// WEBPACK FOOTER //
// ./src/main.js